// Wait for all dependencies before initializing cart
function waitForDependencies(callback) {
  let jQueryReady = false;
  let cartJSReady = false;
  let customCartReady = false;

  // Check if jQuery is ready
  function checkJQuery() {
    if (typeof jQuery !== 'undefined') {
      jQueryReady = true;
      checkAllReady();
    } else {
      setTimeout(checkJQuery, 50);
    }
  }

  // Check if CartJS is ready
  function checkCartJS() {
    if (typeof CartJS !== 'undefined' && typeof CartJS.init === 'function') {
      cartJSReady = true;
      checkAllReady();
    } else {
      setTimeout(checkCartJS, 50);
    }
  }

  // Check if custom cart functions are ready
  function checkCustomCart() {
    // Check if all required cart-related global functions/variables are defined
    const requiredGlobalVars = [
      'checkDiscountGifts',
      'validateGiftsBeforeCheckout',
      'isRemovingFreeItems',
      'isProcessingGifts',
      'automaticGiftsData'
    ];

    const allDefined = requiredGlobalVars.every(varName => typeof window[varName] !== 'undefined');

    if (allDefined) {
      customCartReady = true;
      checkAllReady();
    } else {
      setTimeout(checkCustomCart, 50);
    }
  }

  // Execute callback when all dependencies are ready
  function checkAllReady() {
    if (jQueryReady && cartJSReady && customCartReady) {
      callback();
    }
  }

  // Start checking all dependencies
  checkJQuery();
  checkCartJS();
  checkCustomCart();
}

// Initialize cart when dependencies are ready
waitForDependencies(function() {
  jQuery(document).ready(function($) {
    fetch('/cart.js', {
      method: 'GET',
      headers: {'Content-Type': 'application/json'}
    })
    .then(response => response.json())
    .then(data => {
      CartJS.init(data, {
        "dataAPI": true,
        "moneyFormat": window.moneyFormat,
        "moneyWithCurrencyFormat": window.moneyWithCurrencyFormat
      });
    }).catch((error) => {
      console.error('Error:', error);
    });

  jQuery(document).on('cart.ready', function(event, cart) {
    window.dispatchEvent( new CustomEvent('cart-count-update', {'detail': {cartCount: cart.item_count }}) );
    window.dispatchEvent( new CustomEvent('cart-initiated', {'detail': {cart: cart }}) );
    // Aktualisiere den Warenkorb-Zähler im Header
    updateCartCount(cart.item_count);
  });

  jQuery(document).on('cart.requestStarted', function(event, cart) {
    window.dispatchEvent( new CustomEvent('open-cart', {'detail': {open: true}}) );
    window.dispatchEvent( new CustomEvent('cart-loading', {'detail': {loading: true}}))
  });

  jQuery(document).on('cart.requestComplete', function(event, cart) {
    window.dispatchEvent( new CustomEvent('cart-request-complete', {'detail': {cart: cart, loading: false}}))
    window.dispatchEvent( new CustomEvent('cart-update', {'detail': {cart: cart, loading: false}}))
    window.dispatchEvent( new CustomEvent('cart-count-update', {'detail': {cartCount: cart.item_count }}) );
    
    // Aktualisiere den Warenkorb-Zähler im Header
    updateCartCount(cart.item_count);

    const c = document.querySelector(".header__cart__status");
    if (c) { c.innerHTML = cart.item_count }

    if (cart.item_count == 1 && cart.total_price == 0) {
      CartJS.updateItem(1, 0);
      return;
    } 

    let pricyItems = 0;
    for (const item of cart.items) {
      if (item.price > 0) {
        pricyItems++;
      }
    }
    if (pricyItems == 0 && cart.item_count > 0) {
      CartJS.clear();
      return;
    }

    let n = 1;
    for (const item of cart.items) {
      if (item.price == 0 && item.quantity > 1) {
        CartJS.updateItem(n, 1)
        return;
      }
      n++;
    }
  });
  
  // Funktion zum Aktualisieren des Warenkorb-Zählers
  function updateCartCount(count) {
    const cartCountElement = document.querySelector('[data-js-cart-count-js]');
    if (cartCountElement) {
      cartCountElement.textContent = count;
    }
  }

  // Event-Listener für das cart-count-update Event
  window.addEventListener('cart-count-update', function(event) {
    if (event.detail && event.detail.cartCount !== undefined) {
      updateCartCount(event.detail.cartCount);
    }
  });

  try {
    var url = new URL(window.location.href);
    if (url.searchParams.get('open_cart')) {
      window.dispatchEvent( new CustomEvent('open-cart', {'detail': {open: true}}) );
    }
  } catch (e) {}
  });
});